import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import { ShippingMethod, UpdateShippingMethodVariables, ShippingMethod_adminShippingMethodById, ShippingMethodPriceRangeInput } from '@api/graphql/types';
import Paths from '@root/utils/Path';
import { shouldPriceAppear } from '@root/utils/ShippingMethod';
import Form from '@components/Form/Form';
import PriceRangesField from "../components/PriceRangesField";

type Props = {
    shippingMethodId: string,
} & InjectedIntlProps & RouteComponentProps<{shippingMethodId: string}>;

interface State {
    formData: UpdateShippingMethodVariables;
}

class ShippingMethodEdit extends React.Component<Props, State> {
    public state = {
        formData: {
            id: '',
            code: null,
            name: null,
            is_active: null,
            sort: null,
            price_ranges: [],
            max_weight: null,
            description: null,
            short_description: null,
            delivery_time: null,
        },
    };

    public componentDidMount() {
        GraphQLClient.query<ShippingMethod>({
            query: Queries.adminShippingMethod,
            variables: {id: parseInt(this.props.match.params.shippingMethodId, 10)},
        }).then((response) => {
            if (response.data && response.data.adminShippingMethodById) {
                this.setState({ formData: this.formatFetchedData(response.data.adminShippingMethodById)});
            }
        });
    }

    private formatFetchedData = (data: ShippingMethod_adminShippingMethodById): ShippingMethod_adminShippingMethodById => {
        const newData: ShippingMethod_adminShippingMethodById = { ...data };
        if (newData.price_ranges === null) {
            newData.price_ranges = [];
        }
        return newData;
    }

    public onSubmit = (variables: UpdateShippingMethodVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateShippingMethod, variables: this.filterData(variables),
        });
    }

    private filterData = (data: UpdateShippingMethodVariables): UpdateShippingMethodVariables => {
        return {
            id: data.id,
            name: data.name,
            is_active: data.is_active,
            before: data.before,
            after: data.after,
            price_ranges: data.price_ranges ? data.price_ranges.map((priceRange: ShippingMethodPriceRangeInput) => {
                return {
                    from: priceRange.from,
                    price: priceRange.price,
                };
            }) : [],
            max_weight: data.max_weight,
            description: data.description,
            short_description: data.short_description,
            delivery_time: data.delivery_time,
        };
    }

    private validate(): boolean {
        return true;
    }

    private onPriceRangesChange = (value: any) => {
        this.setState({ formData: { ...this.state.formData, price_ranges: value } });
    }

    private fields = () => {
        let fields = [
            {name: 'name', type: 'text'},
            {name: 'is_active', type: 'checkbox'},
            {name: 'price_ranges', element:
                <PriceRangesField
                    name="price_ranges"
                    value={this.state.formData.price_ranges}
                    onChange={this.onPriceRangesChange}
                />,
            },
            {name: 'max_weight', type: 'number'},
            {name: 'description', type: 'markdown', props: {prefix: 'shipping'}},
            {name: 'short_description', type: 'textarea'},
            {name: 'delivery_time', type: 'textarea'},
        ];

        if (!shouldPriceAppear(this.state.formData.code)) {
            fields = fields.filter((field) => field.name !== 'price_ranges');
        }

        return fields;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <Form
                                fields={[{id: 'default', fields: this.fields()}]}
                                intlPrefix={'module.shippingMethod'}
                                onSubmit={this.onSubmit}
                                formData={this.state.formData}
                                redirectPath={Paths.shippingMethod}
                                validate={this.validate}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { shippingMethodId } = props.match.params;
    return { shippingMethodId };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(ShippingMethodEdit);



// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/pages/ShippingMethodEdit.tsx